module.exports = __webpack_public_path__ + "img/sync_finished.97298ac5.png";